(() => {
  if (window.fkPORInstalled) return;
  window.fkPORInstalled = true;

  const pricedCountries = new Set([
    'IN', 'AE', 'SA', 'QA', 'OM', 'KW', 'BH'
  ]);

  const selectedIds = new Map();
  const subscribed = new Set();

  function configs() {
    return [...document.querySelectorAll('[data-por-config]')]
      .flatMap(el => {
        try {
          return [JSON.parse(el.textContent)];
        } catch (error) {
          console.error('POR configuration', error);
          return [];
        }
      });
  }

  function rootFor(config) {
    return document.getElementById(
      'ProductInfo-' + config.sectionId
    );
  }

  function variantFor(config) {
    const root = rootFor(config);

    const candidate =
      selectedIds.get(String(config.sectionId)) ||
      root?.querySelector('.product-variant-id')?.value ||
      config.initialVariantId;

    return (
      config.variants[String(candidate)] ||
      config.variants[String(config.initialVariantId)]
    );
  }

  function isPOR(config, variant) {
    const country = String(config.country || '').toUpperCase();

    const countryAllowsPrice = config.isMiracleMan === true
      ? country === 'IN'
      : pricedCountries.has(country);

    return (
      config.productPOR === true ||
      variant?.por === true ||
      !countryAllowsPrice
    );
  }

  function toggle(el, visible, display = '') {
    if (!el) return;

    const value = visible ? 'false' : 'true';

    if (el.dataset.porHidden !== value) {
      el.dataset.porHidden = value;
    }

    const desiredDisplay = visible ? display : 'none';

    if (el.style.display !== desiredDisplay) {
      el.style.display = desiredDisplay;
    }
  }

  function text(el, value) {
    if (el && el.textContent !== value) {
      el.textContent = value;
    }
  }

  function priceBlock(block, por, variant) {
    if (!block || !variant) return;

    toggle(block.querySelector('.price_on_request_text'), por);

    const regular = block.querySelector('.f-price__regular');
    const sale = block.querySelector('.f-price__sale');

    toggle(regular, !por);
    toggle(sale, !por && variant.onSale);

    if (variant.onSale && !por) {
      block.classList.add('f-price--on-sale');
    } else {
      block.classList.remove('f-price--on-sale');
    }

    text(
      regular?.querySelector('.f-price-item'),
      por ? '' : variant.price
    );

    text(
      sale?.querySelector('.f-price-item--sale'),
      por ? '' : variant.price
    );

    text(
      sale?.querySelector('s'),
      por ? '' : variant.compare
    );

    const unitWrapper = block.querySelector(
      '.f-price__unit-wrapper'
    );

    toggle(
      unitWrapper,
      !por && !unitWrapper?.classList.contains('hidden')
    );

    toggle(block.querySelector('.f-price__badges'), !por);
  }

  function apply(config) {
    const root = rootFor(config);
    if (!root) return;

    const variant = variantFor(config);
    const por = isPOR(config, variant);

    root.dataset.porActive = String(por);

    root.querySelectorAll('.f-price').forEach(block => {
      priceBlock(block, por, variant);
    });

    toggle(root.querySelector('.atc-form-wrapper'), !por);
    toggle(root.querySelector('.contact_us'), por);

    const sticky = [
      ...document.querySelectorAll('sticky-atc-bar')
    ].find(el => {
      return String(el.dataset.productId) ===
        String(config.productId);
    });

    if (sticky) {
      sticky.closest('.sticky-atc-bar')
        ?.classList.remove('hide_price_on_request');

      toggle(
        sticky.querySelector('.sticky-atc-form-wrapper'),
        !por
      );

      toggle(
        sticky.querySelector('.product-form-contact-us'),
        por,
        'flex'
      );

      sticky.querySelectorAll('.f-price').forEach(block => {
        priceBlock(block, por, variant);
      });
    }
  }

  function applyAll() {
    configs().forEach(apply);
  }

  function changed(sectionId, variantId) {
    if (sectionId && variantId) {
      selectedIds.set(
        String(sectionId),
        String(variantId)
      );
    }

    applyAll();
    setTimeout(applyAll, 150);
    setTimeout(applyAll, 450);
  }

  function init() {
    configs().forEach(config => {
      const pubsub = window.FoxTheme?.pubsub;
      const eventName = pubsub?.PUB_SUB_EVENTS?.variantChange;

      if (
        eventName &&
        !subscribed.has(String(config.sectionId))
      ) {
        pubsub.subscribe(eventName, event => {
          const value = event.data || event;

          if (
            String(value.sectionId) === String(config.sectionId) &&
            value.variant?.id
          ) {
            changed(config.sectionId, value.variant.id);
          }
        });

        subscribed.add(String(config.sectionId));
      }
    });

    applyAll();
  }

  document.addEventListener('variant:changed', event => {
    const id = event.detail?.variant?.id;

    const root = event.target.closest?.(
      '[id^="ProductInfo-"]'
    );

    const section =
      event.detail?.sectionId ||
      root?.dataset.section;

    if (section && id) {
      changed(section, id);
    } else {
      setTimeout(applyAll, 150);
    }
  });

  document.addEventListener('change', event => {
    const root = event.target.closest?.(
      '[id^="ProductInfo-"]'
    );

    const sticky = event.target.closest?.('sticky-atc-bar');

    if (!root && !sticky) return;

    if (
      sticky &&
      event.target.matches('select[name="id"]')
    ) {
      configs()
        .filter(config => {
          return String(config.productId) ===
            String(sticky.dataset.productId);
        })
        .forEach(config => {
          changed(config.sectionId, event.target.value);
        });
    } else {
      if (root) {
        selectedIds.delete(String(root.dataset.section));
      }

      setTimeout(applyAll, 150);
      setTimeout(applyAll, 450);
    }
  });

  document.addEventListener('submit', event => {
    const root = event.target.closest?.(
      '[id^="ProductInfo-"]'
    );

    const sticky = event.target.closest?.('sticky-atc-bar');

    const config = configs().find(config => {
      return root
        ? String(config.sectionId) === String(root.dataset.section)
        : sticky &&
          String(config.productId) ===
            String(sticky.dataset.productId);
    });

    if (
      config &&
      isPOR(config, variantFor(config)) &&
      event.target.matches('form[action*="/cart/add"]')
    ) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }, true);

  document.addEventListener('click', event => {
    const button = event.target.closest?.('[data-por-request]');
    if (!button) return;

    event.preventDefault();

    const root = button.closest('[id^="ProductInfo-"]');
    const sticky = button.closest('sticky-atc-bar');

    const config = configs().find(config => {
      return root
        ? String(config.sectionId) === String(root.dataset.section)
        : sticky &&
          String(config.productId) ===
            String(sticky.dataset.productId);
    });

    const drawerRoot = config ? rootFor(config) : root;

    drawerRoot
      ?.querySelector('.cstm_product_drawer_contact')
      ?.classList.add('active');

    drawerRoot
      ?.querySelector('.login_drawer_dr .engraving_overlay')
      ?.classList.add('active');

    document.body.classList.add('drawer-open-cstm');
  });

  document.addEventListener('shopify:section:load', init);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.addEventListener('load', init, { once: true });
})();
